module.exports = __webpack_public_path__ + "adc85b9b8d48ee1782e127ece7ebd4e6.svg";